import { useState } from "react";
import { useQuery } from "react-query";
import { Moment } from "moment";
import {
  getPreOrderUnit,
  PreOrderUnitFilters,
  PreOrderUnitResponse,
} from "Requests/PreOrder";

export type FiltersState = {
  searchType: string;
  searchValue: string;
  start_date: Moment | undefined;
  end_date: Moment | undefined;
  unit: string;
  preOrderType: string;
  status_id: number[];
};

export const initialPrePreOrderFilters: FiltersState = {
  searchType: "",
  searchValue: "",
  start_date: undefined,
  end_date: undefined,
  unit: "",
  preOrderType: "",
  status_id: [],
};

function buildPreOrderUnitRequest(
  filters: FiltersState,
  page: number
): PreOrderUnitFilters {
  const request: PreOrderUnitFilters = {
    page,
    per_page: "10",
  };

  if (filters.start_date) {
    request.start_date = filters.start_date.format("YYYY-MM-DD");
  }

  if (filters.end_date) {
    request.end_date = filters.end_date.format("YYYY-MM-DD");
  }

  if (filters.unit) {
    request.unit_id = filters.unit;
  }

  if (filters.status_id.length > 0) {
    request.status_id = filters.status_id;
  }

  if (filters.preOrderType === "convenio") {
    request.have_health_insurance = true;
  }

  if (filters.preOrderType === "particular") {
    request.have_health_insurance = false;
  }

  const trimmedSearch = filters.searchValue.trim();

  if (filters.searchType && trimmedSearch) {
    if (filters.searchType === "name") {
      request.name = trimmedSearch;
    }

    if (filters.searchType === "email") {
      request.email = trimmedSearch;
    }

    if (filters.searchType === "phone") {
      request.phone = trimmedSearch;
    }

    if (filters.searchType === "document") {
      request.document = trimmedSearch;
    }
  }

  return request;
}

export const usePrePreOrderListUnit = () => {
  const [pageSelected, setPageSelected] = useState(1);

  const [filters, setFilters] = useState<FiltersState>(
    initialPrePreOrderFilters
  );

  const prePreOrderList = useQuery<PreOrderUnitResponse | undefined>({
    queryFn: () =>
      getPreOrderUnit(buildPreOrderUnitRequest(filters, pageSelected)),
    queryKey: [
      "listAllPrePreOrderUnit",
      pageSelected,
      {
        ...filters,
      },
    ],
    refetchOnWindowFocus: false,
  });

  const updateFilters = (searchFilter: FiltersState) => {
    setFilters({ ...searchFilter });
  };

  const setNewPage = (page: number) => {
    setPageSelected(page);
  };

  function handlePagination(event: { currentPage: number }) {
    if (pageSelected === event.currentPage) return;
    setNewPage(event.currentPage);
  }

  return {
    prePreOrderList,
    setNewPage,
    setFilters: updateFilters,
    handlePagination,
  };
};
